import React from "react";
import { useTranslations } from 'next-intl'

const PriceInput = ({ id, name, shortName, addEstate, error, onChange, disabled, value, verticalRange, isRange, isHomePage }: any) => {
  const t = useTranslations('')

  const renderInput = (placeholder: any, valueKey: any) => (
        <div className="input-dollar-wrapper">
            {addEstate &&
                <label htmlFor={id} className="form-label">{name}</label>
            }
          <div className="input-group">
            <input
                type="number"
                className="form-control"
                placeholder={placeholder}
                id={`${id}-${valueKey}`}
                name={`${id}-${valueKey}`}
                value={value?.[valueKey] ?? ""}
                onChange={(e) => onChange(e, valueKey)}
                disabled={disabled}
            />
            {!isHomePage && <span className="input-group-text">$</span>}
          </div>
        </div>
    );

    return (
        <div className="mb-3">
            <div className="row">
                {(!isHomePage && !addEstate) &&
                  <label htmlFor={id} className="form-label">{shortName}</label>
                }
                <div className={`${verticalRange ? "col-md-12 mb-16" : ""} ${isRange && !verticalRange ? "col-md-6" : ""} mobile-mb-16`}>
                    {renderInput(isHomePage ? `${t("Min")} ${shortName}` : t("Min"), "min")}
                </div>
                <div className={`${verticalRange ? "col-md-12" : ""} ${isRange && !verticalRange ? "col-md-6" : ""}`}>
                    {renderInput(isHomePage ? `${t("Max")} ${shortName}`: t('Max'), "max")}
                </div>
            </div>
            {error && <div className="text-danger">{error.join(" ")}</div>}
        </div>
    );
};

export default PriceInput;
